import styled from 'styled-components';
import Modal from '../../CommonComponents/Modal';
import { StyledButton as Button } from '../../CommonComponents/Button';

export const StyledModal = styled(Modal)`
  &__content {
    width: 550px;
    border-radius: 4px;
  }
`;

export const Body = styled.div`
  padding: 40px 85px;
`;

export const Footer = styled.div`
  border-top: 1px solid rgba(151, 151, 151, 0.39);
  padding: 15px 25px;
  text-align: right;

  ${Button} {
    padding: 15px 60px;
  }

  ${Button} + ${Button} {
    margin-left: 10px;
  }
`;

export const Title = styled.span`
  font-size: 24px;
  color: #444444;
  display: block;
  margin-bottom: 25px;
`;

export const Subtitle = styled.span`
  display: block;
  font-size: 14px;
  color: #6C727F;
  margin-bottom: 15px;
`;

export const TextArea = styled.textarea.attrs({
  rows: 7,
})`
  font-size: 16px;
  padding: 10px 17px;
  line-height: 1.81;
  color: #4b4d4e;
  width: 100%;
  border: 1px solid #cac8c8;
  display: block;
  margin-bottom: 15px;
  box-sizing: border-box;
  resize: vertical;
`;

export const CharacterCounter = styled.span`
  display: block;
  text-align: right;
  color: #4b4d4e;
`;
